import React, { useEffect, useState } from 'react';
import { ClientStorageBrowser } from '../../../components/storage';
import type { ExportFormState } from '../../../types/export';

interface Props {
  onChange: (patch: Partial<ExportFormState>) => void;
  projectId: string;
}

// Step 2.5 — only shown when "Save to Client Storage" is selected in Step 2.
// Reuses the shared Client Storage browser filtered to folders. Destination =
// the explicitly selected folder, falling back to the folder currently open;
// navigating into a new folder clears any stale selection.
export function Step2_5ClientStorage({ onChange, projectId }: Props) {
  const [selectedPath, setSelectedPath] = useState<string | null>(null);
  const [matterId, setMatterId] = useState<string | undefined>(undefined);
  const [baseDir, setBaseDir] = useState('');

  // The upload directory is absolute under the matter root. Until the listing reports the
  // matter id there is no valid destination — emit '' so the step stays invalid rather than
  // sending "/Matters/undefined/...".
  useEffect(() => {
    onChange({
      clientStorageUploadDirectory: matterId ? `/Matters/${matterId}/${selectedPath ?? baseDir}` : '',
    });
  }, [selectedPath, baseDir, matterId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <p className="text-muted">
        Select a destination folder, or open one to export into the folder you're viewing.
      </p>
      <ClientStorageBrowser
        foldersOnly
        projectId={projectId}
        selectedPath={selectedPath}
        onPathChange={setSelectedPath}
        onBaseDirChange={dir => { setBaseDir(dir); setSelectedPath(null); }}
        onBucketChange={b => onChange({ clientStorageBucketName: b })}
        onMatterIdChange={setMatterId}
        disabled={false}
        showEmptyAlert={false}
        testId="export-wizard-storage-panel"
      />
    </div>
  );
}
